import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Home from '../modules/home';
import Inscriptions from '../modules/Inscriptions';
import ScrollToTop from './ScrollToTop';
import CookiesBanner from '../components/CookiesBanner';

const ViewsContainer = () => (
	<>
		<ScrollToTop>
			<Switch>
				<Route exact path={'/'} component={Home} />
				<Route exact path={'/inscriptions'} component={Inscriptions} />
			</Switch>
			<CookiesBanner />
		</ScrollToTop>
	</>
);

export default ViewsContainer;
